import React from 'react';
import './PincodeSelectModal.css';

const PincodeSelectModal = ({ isOpen, onClose, options = [], onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="pincode-sel-overlay" onClick={onClose}>
      <div className="pincode-sel-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pincode-sel-header">
          <h3>Select Area / Post Office</h3>
          <button type="button" className="pincode-sel-close-x" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="pincode-sel-body">
          <p className="pincode-sel-subtitle">
            Multiple locations found for this pincode. Please select one:
          </p>
          <div className="pincode-sel-options-list">
            {options.map((opt, idx) => (
              <button
                key={idx}
                type="button"
                className="pincode-sel-option-btn"
                onClick={() => {
                  onSelect(opt);
                  onClose();
                }}
              >
                <span className="pincode-sel-option-city">{opt.city}</span>
                <span className="pincode-sel-option-meta">
                  {opt.district}, {opt.state}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PincodeSelectModal;
